/* eslint-disable @typescript-eslint/naming-convention */
// internal-deps
import { AnalyticsContextValue, GlobalHeaderState } from "@swiggy-private/checkout-core";
import { SwgyHeaderKeysList } from "@swiggy-private/checkout-types";

// constants
import { SCREEN_NAME, IMPRESSION_ACTIONS, CLICK_ACTIONS } from "../constants";
import { IIrctcPayload, IrctcAddressChangeFormKeys } from "@swiggy-private/cart-types";

export const impressionIrctcUpdateAddress = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    irctcData?: IIrctcPayload,
): void => {
    const { berth, station_name, coach, mobile_number } = irctcData || {};
    const source = GlobalHeaderState.getHeader(SwgyHeaderKeysList.xChannel) || "";
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.USER_DETAILS_BANNER_IRCTC,
        context: irctcData ? JSON.stringify({ berth, station: station_name, coach, mobile: mobile_number }) : undefined,
        extraParams: JSON.stringify({ is_irctc_event: true, source }),
    });
};

export const clickIrctcEditCta = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    ctaType?: IrctcAddressChangeFormKeys,
    irctcData?: IIrctcPayload,
): void => {
    const { berth, coach, mobile_number } = irctcData || {};
    const source = GlobalHeaderState.getHeader(SwgyHeaderKeysList.xChannel) || "";
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action:
            ctaType === IrctcAddressChangeFormKeys.COACH_NO
                ? CLICK_ACTIONS.USER_DETAILS_SEAT_IRCTC
                : CLICK_ACTIONS.USER_DETAILS_CONTACT_IRCTC,
        context: irctcData ? JSON.stringify({ berth: berth, coach: coach, mobile: mobile_number }) : undefined,
        extraParams: JSON.stringify({ is_irctc_event: true, source }),
    });
};
